export const SET_PAYROLL_SUMMARY_LOADING = 'SET_PAYROLL_SUMMARY_LOADING'
export const SET_PAYROLL_SUMMARY = 'SET_PAYROLL_SUMMARY'
export const ADD_PAYROLL_SUMMARY = 'ADD_PAYROLL_SUMMARY'
export const EDIT_PAYROLL_SUMMARY = 'EDIT_PAYROLL_SUMMARY'
export const DELETE_PAYROLL_SUMMARY = 'DELETE_PAYROLL_SUMMARY'
export const APPROV_PAYROLL_SUMMARY = 'APPROV_PAYROLL_SUMMARY'
export const SET_PAYROLL_HEADER = 'SET_PAYROLL_HEADER'
export const GET_SCHEDULE_SETTING_DATA = "GET_SCHEDULE_SETTING_DATA";